/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PlainRouteRouteImport } from './routes/_plain/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAboutRouteImport } from './routes/_app/about'
import { Route as AppSitesIndexRouteImport } from './routes/_app/sites/index'
import { Route as AppProceduresIndexRouteImport } from './routes/_app/procedures/index'
import { Route as AppPatientsIndexRouteImport } from './routes/_app/patients/index'
import { Route as AppConsentsIndexRouteImport } from './routes/_app/consents/index'
import { Route as AuthloginVerifyRouteImport } from './routes/_auth/(login)/verify'
import { Route as AuthloginMfaRouteImport } from './routes/_auth/(login)/mfa'
import { Route as AuthloginLoginRouteImport } from './routes/_auth/(login)/login'
import { Route as AuthforgotPasswordResetPasswordRouteImport } from './routes/_auth/(forgot-password)/reset-password'
import { Route as AuthforgotPasswordPasswordUpdatedRouteImport } from './routes/_auth/(forgot-password)/password-updated'
import { Route as AuthforgotPasswordForgotPasswordRouteImport } from './routes/_auth/(forgot-password)/forgot-password'
import { Route as AuthforgotPasswordCodeSentRouteImport } from './routes/_auth/(forgot-password)/code-sent'
import { Route as AuthfirstLoginSetupMfaRouteImport } from './routes/_auth/(first-login)/setup-mfa'
import { Route as AuthfirstLoginSetNewPasswordRouteImport } from './routes/_auth/(first-login)/set-new-password'
import { Route as AuthfirstLoginPasswordSetRouteImport } from './routes/_auth/(first-login)/password-set'
import { Route as AuthfirstLoginInvitationExpiredRouteImport } from './routes/_auth/(first-login)/invitation-expired'
import { Route as AuthfirstLoginFirstTimeLoginRouteImport } from './routes/_auth/(first-login)/first-time-login'
import { Route as AppConsentsTemplateIdRouteImport } from './routes/_app/consents/$templateId'
import { Route as PlainCockpitProcedureIdRouteRouteImport } from './routes/_plain/cockpit/$procedureId/route'
import { Route as AppSubjectsSubjectIdIndexRouteImport } from './routes/_app/subjects/$subjectId/index'
import { Route as AppSitesSiteIdIndexRouteImport } from './routes/_app/sites/$siteId/index'
import { Route as AppProceduresProcedureIdIndexRouteImport } from './routes/_app/procedures/$procedureId/index'
import { Route as AppPatientsPatientIdIndexRouteImport } from './routes/_app/patients/$patientId/index'
import { Route as PlainCockpitProcedureIdTreatmentRouteImport } from './routes/_plain/cockpit/$procedureId/treatment'
import { Route as PlainCockpitProcedureIdOverviewRouteImport } from './routes/_plain/cockpit/$procedureId/overview'
import { Route as AppPatientsPatientIdProceduresProcedureIdCueingIndexRouteImport } from './routes/_app/patients/$patientId/procedures/$procedureId/cueing/index'
import { Route as AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdResponseRouteImport } from './routes/_app/patients/$patientId/phases/$phaseId/assessments/$assessmentId/response'
import { Route as AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdQuestionnaireRouteImport } from './routes/_app/patients/$patientId/phases/$phaseId/assessments/$assessmentId/questionnaire'

const PlainRouteRoute = PlainRouteRouteImport.update({
  id: '/_plain',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAboutRoute = AppAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSitesIndexRoute = AppSitesIndexRouteImport.update({
  id: '/sites/',
  path: '/sites/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProceduresIndexRoute = AppProceduresIndexRouteImport.update({
  id: '/procedures/',
  path: '/procedures/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPatientsIndexRoute = AppPatientsIndexRouteImport.update({
  id: '/patients/',
  path: '/patients/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppConsentsIndexRoute = AppConsentsIndexRouteImport.update({
  id: '/consents/',
  path: '/consents/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthloginVerifyRoute = AuthloginVerifyRouteImport.update({
  id: '/(login)/verify',
  path: '/verify',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthloginMfaRoute = AuthloginMfaRouteImport.update({
  id: '/(login)/mfa',
  path: '/mfa',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthloginLoginRoute = AuthloginLoginRouteImport.update({
  id: '/(login)/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthforgotPasswordResetPasswordRoute =
  AuthforgotPasswordResetPasswordRouteImport.update({
    id: '/(forgot-password)/reset-password',
    path: '/reset-password',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthforgotPasswordPasswordUpdatedRoute =
  AuthforgotPasswordPasswordUpdatedRouteImport.update({
    id: '/(forgot-password)/password-updated',
    path: '/password-updated',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthforgotPasswordForgotPasswordRoute =
  AuthforgotPasswordForgotPasswordRouteImport.update({
    id: '/(forgot-password)/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthforgotPasswordCodeSentRoute =
  AuthforgotPasswordCodeSentRouteImport.update({
    id: '/(forgot-password)/code-sent',
    path: '/code-sent',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthfirstLoginSetupMfaRoute = AuthfirstLoginSetupMfaRouteImport.update({
  id: '/(first-login)/setup-mfa',
  path: '/setup-mfa',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthfirstLoginSetNewPasswordRoute =
  AuthfirstLoginSetNewPasswordRouteImport.update({
    id: '/(first-login)/set-new-password',
    path: '/set-new-password',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthfirstLoginPasswordSetRoute =
  AuthfirstLoginPasswordSetRouteImport.update({
    id: '/(first-login)/password-set',
    path: '/password-set',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthfirstLoginInvitationExpiredRoute =
  AuthfirstLoginInvitationExpiredRouteImport.update({
    id: '/(first-login)/invitation-expired',
    path: '/invitation-expired',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthfirstLoginFirstTimeLoginRoute =
  AuthfirstLoginFirstTimeLoginRouteImport.update({
    id: '/(first-login)/first-time-login',
    path: '/first-time-login',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AppConsentsTemplateIdRoute = AppConsentsTemplateIdRouteImport.update({
  id: '/consents/$templateId',
  path: '/consents/$templateId',
  getParentRoute: () => AppRouteRoute,
} as any)
const PlainCockpitProcedureIdRouteRoute =
  PlainCockpitProcedureIdRouteRouteImport.update({
    id: '/cockpit/$procedureId',
    path: '/cockpit/$procedureId',
    getParentRoute: () => PlainRouteRoute,
  } as any)
const AppSubjectsSubjectIdIndexRoute =
  AppSubjectsSubjectIdIndexRouteImport.update({
    id: '/subjects/$subjectId/',
    path: '/subjects/$subjectId/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSitesSiteIdIndexRoute = AppSitesSiteIdIndexRouteImport.update({
  id: '/sites/$siteId/',
  path: '/sites/$siteId/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProceduresProcedureIdIndexRoute =
  AppProceduresProcedureIdIndexRouteImport.update({
    id: '/procedures/$procedureId/',
    path: '/procedures/$procedureId/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppPatientsPatientIdIndexRoute =
  AppPatientsPatientIdIndexRouteImport.update({
    id: '/patients/$patientId/',
    path: '/patients/$patientId/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const PlainCockpitProcedureIdTreatmentRoute =
  PlainCockpitProcedureIdTreatmentRouteImport.update({
    id: '/treatment',
    path: '/treatment',
    getParentRoute: () => PlainCockpitProcedureIdRouteRoute,
  } as any)
const PlainCockpitProcedureIdOverviewRoute =
  PlainCockpitProcedureIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => PlainCockpitProcedureIdRouteRoute,
  } as any)
const AppPatientsPatientIdProceduresProcedureIdCueingIndexRoute =
  AppPatientsPatientIdProceduresProcedureIdCueingIndexRouteImport.update({
    id: '/patients/$patientId/procedures/$procedureId/cueing/',
    path: '/patients/$patientId/procedures/$procedureId/cueing/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdResponseRoute =
  AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdResponseRouteImport.update(
    {
      id: '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/response',
      path: '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/response',
      getParentRoute: () => AppRouteRoute,
    } as any,
  )
const AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdQuestionnaireRoute =
  AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdQuestionnaireRouteImport.update(
    {
      id: '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/questionnaire',
      path: '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/questionnaire',
      getParentRoute: () => AppRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/about': typeof AppAboutRoute
  '/': typeof AppIndexRoute
  '/cockpit/$procedureId': typeof PlainCockpitProcedureIdRouteRouteWithChildren
  '/consents/$templateId': typeof AppConsentsTemplateIdRoute
  '/first-time-login': typeof AuthfirstLoginFirstTimeLoginRoute
  '/invitation-expired': typeof AuthfirstLoginInvitationExpiredRoute
  '/password-set': typeof AuthfirstLoginPasswordSetRoute
  '/set-new-password': typeof AuthfirstLoginSetNewPasswordRoute
  '/setup-mfa': typeof AuthfirstLoginSetupMfaRoute
  '/code-sent': typeof AuthforgotPasswordCodeSentRoute
  '/forgot-password': typeof AuthforgotPasswordForgotPasswordRoute
  '/password-updated': typeof AuthforgotPasswordPasswordUpdatedRoute
  '/reset-password': typeof AuthforgotPasswordResetPasswordRoute
  '/login': typeof AuthloginLoginRoute
  '/mfa': typeof AuthloginMfaRoute
  '/verify': typeof AuthloginVerifyRoute
  '/consents': typeof AppConsentsIndexRoute
  '/patients': typeof AppPatientsIndexRoute
  '/procedures': typeof AppProceduresIndexRoute
  '/sites': typeof AppSitesIndexRoute
  '/cockpit/$procedureId/overview': typeof PlainCockpitProcedureIdOverviewRoute
  '/cockpit/$procedureId/treatment': typeof PlainCockpitProcedureIdTreatmentRoute
  '/patients/$patientId': typeof AppPatientsPatientIdIndexRoute
  '/procedures/$procedureId': typeof AppProceduresProcedureIdIndexRoute
  '/sites/$siteId': typeof AppSitesSiteIdIndexRoute
  '/subjects/$subjectId': typeof AppSubjectsSubjectIdIndexRoute
  '/patients/$patientId/procedures/$procedureId/cueing': typeof AppPatientsPatientIdProceduresProcedureIdCueingIndexRoute
  '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/questionnaire': typeof AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdQuestionnaireRoute
  '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/response': typeof AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdResponseRoute
}
export interface FileRoutesByTo {
  '/about': typeof AppAboutRoute
  '/': typeof AppIndexRoute
  '/cockpit/$procedureId': typeof PlainCockpitProcedureIdRouteRouteWithChildren
  '/consents/$templateId': typeof AppConsentsTemplateIdRoute
  '/first-time-login': typeof AuthfirstLoginFirstTimeLoginRoute
  '/invitation-expired': typeof AuthfirstLoginInvitationExpiredRoute
  '/password-set': typeof AuthfirstLoginPasswordSetRoute
  '/set-new-password': typeof AuthfirstLoginSetNewPasswordRoute
  '/setup-mfa': typeof AuthfirstLoginSetupMfaRoute
  '/code-sent': typeof AuthforgotPasswordCodeSentRoute
  '/forgot-password': typeof AuthforgotPasswordForgotPasswordRoute
  '/password-updated': typeof AuthforgotPasswordPasswordUpdatedRoute
  '/reset-password': typeof AuthforgotPasswordResetPasswordRoute
  '/login': typeof AuthloginLoginRoute
  '/mfa': typeof AuthloginMfaRoute
  '/verify': typeof AuthloginVerifyRoute
  '/consents': typeof AppConsentsIndexRoute
  '/patients': typeof AppPatientsIndexRoute
  '/procedures': typeof AppProceduresIndexRoute
  '/sites': typeof AppSitesIndexRoute
  '/cockpit/$procedureId/overview': typeof PlainCockpitProcedureIdOverviewRoute
  '/cockpit/$procedureId/treatment': typeof PlainCockpitProcedureIdTreatmentRoute
  '/patients/$patientId': typeof AppPatientsPatientIdIndexRoute
  '/procedures/$procedureId': typeof AppProceduresProcedureIdIndexRoute
  '/sites/$siteId': typeof AppSitesSiteIdIndexRoute
  '/subjects/$subjectId': typeof AppSubjectsSubjectIdIndexRoute
  '/patients/$patientId/procedures/$procedureId/cueing': typeof AppPatientsPatientIdProceduresProcedureIdCueingIndexRoute
  '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/questionnaire': typeof AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdQuestionnaireRoute
  '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/response': typeof AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdResponseRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_plain': typeof PlainRouteRouteWithChildren
  '/_app/about': typeof AppAboutRoute
  '/_app/': typeof AppIndexRoute
  '/_plain/cockpit/$procedureId': typeof PlainCockpitProcedureIdRouteRouteWithChildren
  '/_app/consents/$templateId': typeof AppConsentsTemplateIdRoute
  '/_auth/(first-login)/first-time-login': typeof AuthfirstLoginFirstTimeLoginRoute
  '/_auth/(first-login)/invitation-expired': typeof AuthfirstLoginInvitationExpiredRoute
  '/_auth/(first-login)/password-set': typeof AuthfirstLoginPasswordSetRoute
  '/_auth/(first-login)/set-new-password': typeof AuthfirstLoginSetNewPasswordRoute
  '/_auth/(first-login)/setup-mfa': typeof AuthfirstLoginSetupMfaRoute
  '/_auth/(forgot-password)/code-sent': typeof AuthforgotPasswordCodeSentRoute
  '/_auth/(forgot-password)/forgot-password': typeof AuthforgotPasswordForgotPasswordRoute
  '/_auth/(forgot-password)/password-updated': typeof AuthforgotPasswordPasswordUpdatedRoute
  '/_auth/(forgot-password)/reset-password': typeof AuthforgotPasswordResetPasswordRoute
  '/_auth/(login)/login': typeof AuthloginLoginRoute
  '/_auth/(login)/mfa': typeof AuthloginMfaRoute
  '/_auth/(login)/verify': typeof AuthloginVerifyRoute
  '/_app/consents/': typeof AppConsentsIndexRoute
  '/_app/patients/': typeof AppPatientsIndexRoute
  '/_app/procedures/': typeof AppProceduresIndexRoute
  '/_app/sites/': typeof AppSitesIndexRoute
  '/_plain/cockpit/$procedureId/overview': typeof PlainCockpitProcedureIdOverviewRoute
  '/_plain/cockpit/$procedureId/treatment': typeof PlainCockpitProcedureIdTreatmentRoute
  '/_app/patients/$patientId/': typeof AppPatientsPatientIdIndexRoute
  '/_app/procedures/$procedureId/': typeof AppProceduresProcedureIdIndexRoute
  '/_app/sites/$siteId/': typeof AppSitesSiteIdIndexRoute
  '/_app/subjects/$subjectId/': typeof AppSubjectsSubjectIdIndexRoute
  '/_app/patients/$patientId/procedures/$procedureId/cueing/': typeof AppPatientsPatientIdProceduresProcedureIdCueingIndexRoute
  '/_app/patients/$patientId/phases/$phaseId/assessments/$assessmentId/questionnaire': typeof AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdQuestionnaireRoute
  '/_app/patients/$patientId/phases/$phaseId/assessments/$assessmentId/response': typeof AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdResponseRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/about'
    | '/'
    | '/cockpit/$procedureId'
    | '/consents/$templateId'
    | '/first-time-login'
    | '/invitation-expired'
    | '/password-set'
    | '/set-new-password'
    | '/setup-mfa'
    | '/code-sent'
    | '/forgot-password'
    | '/password-updated'
    | '/reset-password'
    | '/login'
    | '/mfa'
    | '/verify'
    | '/consents'
    | '/patients'
    | '/procedures'
    | '/sites'
    | '/cockpit/$procedureId/overview'
    | '/cockpit/$procedureId/treatment'
    | '/patients/$patientId'
    | '/procedures/$procedureId'
    | '/sites/$siteId'
    | '/subjects/$subjectId'
    | '/patients/$patientId/procedures/$procedureId/cueing'
    | '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/questionnaire'
    | '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/response'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/about'
    | '/'
    | '/cockpit/$procedureId'
    | '/consents/$templateId'
    | '/first-time-login'
    | '/invitation-expired'
    | '/password-set'
    | '/set-new-password'
    | '/setup-mfa'
    | '/code-sent'
    | '/forgot-password'
    | '/password-updated'
    | '/reset-password'
    | '/login'
    | '/mfa'
    | '/verify'
    | '/consents'
    | '/patients'
    | '/procedures'
    | '/sites'
    | '/cockpit/$procedureId/overview'
    | '/cockpit/$procedureId/treatment'
    | '/patients/$patientId'
    | '/procedures/$procedureId'
    | '/sites/$siteId'
    | '/subjects/$subjectId'
    | '/patients/$patientId/procedures/$procedureId/cueing'
    | '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/questionnaire'
    | '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/response'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_plain'
    | '/_app/about'
    | '/_app/'
    | '/_plain/cockpit/$procedureId'
    | '/_app/consents/$templateId'
    | '/_auth/(first-login)/first-time-login'
    | '/_auth/(first-login)/invitation-expired'
    | '/_auth/(first-login)/password-set'
    | '/_auth/(first-login)/set-new-password'
    | '/_auth/(first-login)/setup-mfa'
    | '/_auth/(forgot-password)/code-sent'
    | '/_auth/(forgot-password)/forgot-password'
    | '/_auth/(forgot-password)/password-updated'
    | '/_auth/(forgot-password)/reset-password'
    | '/_auth/(login)/login'
    | '/_auth/(login)/mfa'
    | '/_auth/(login)/verify'
    | '/_app/consents/'
    | '/_app/patients/'
    | '/_app/procedures/'
    | '/_app/sites/'
    | '/_plain/cockpit/$procedureId/overview'
    | '/_plain/cockpit/$procedureId/treatment'
    | '/_app/patients/$patientId/'
    | '/_app/procedures/$procedureId/'
    | '/_app/sites/$siteId/'
    | '/_app/subjects/$subjectId/'
    | '/_app/patients/$patientId/procedures/$procedureId/cueing/'
    | '/_app/patients/$patientId/phases/$phaseId/assessments/$assessmentId/questionnaire'
    | '/_app/patients/$patientId/phases/$phaseId/assessments/$assessmentId/response'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  PlainRouteRoute: typeof PlainRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_plain': {
      id: '/_plain'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PlainRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/about': {
      id: '/_app/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AppAboutRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/sites/': {
      id: '/_app/sites/'
      path: '/sites'
      fullPath: '/sites'
      preLoaderRoute: typeof AppSitesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/procedures/': {
      id: '/_app/procedures/'
      path: '/procedures'
      fullPath: '/procedures'
      preLoaderRoute: typeof AppProceduresIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/patients/': {
      id: '/_app/patients/'
      path: '/patients'
      fullPath: '/patients'
      preLoaderRoute: typeof AppPatientsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/consents/': {
      id: '/_app/consents/'
      path: '/consents'
      fullPath: '/consents'
      preLoaderRoute: typeof AppConsentsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_auth/(login)/verify': {
      id: '/_auth/(login)/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof AuthloginVerifyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/(login)/mfa': {
      id: '/_auth/(login)/mfa'
      path: '/mfa'
      fullPath: '/mfa'
      preLoaderRoute: typeof AuthloginMfaRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/(login)/login': {
      id: '/_auth/(login)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthloginLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/(forgot-password)/reset-password': {
      id: '/_auth/(forgot-password)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthforgotPasswordResetPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/(forgot-password)/password-updated': {
      id: '/_auth/(forgot-password)/password-updated'
      path: '/password-updated'
      fullPath: '/password-updated'
      preLoaderRoute: typeof AuthforgotPasswordPasswordUpdatedRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/(forgot-password)/forgot-password': {
      id: '/_auth/(forgot-password)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthforgotPasswordForgotPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/(forgot-password)/code-sent': {
      id: '/_auth/(forgot-password)/code-sent'
      path: '/code-sent'
      fullPath: '/code-sent'
      preLoaderRoute: typeof AuthforgotPasswordCodeSentRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/(first-login)/setup-mfa': {
      id: '/_auth/(first-login)/setup-mfa'
      path: '/setup-mfa'
      fullPath: '/setup-mfa'
      preLoaderRoute: typeof AuthfirstLoginSetupMfaRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/(first-login)/set-new-password': {
      id: '/_auth/(first-login)/set-new-password'
      path: '/set-new-password'
      fullPath: '/set-new-password'
      preLoaderRoute: typeof AuthfirstLoginSetNewPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/(first-login)/password-set': {
      id: '/_auth/(first-login)/password-set'
      path: '/password-set'
      fullPath: '/password-set'
      preLoaderRoute: typeof AuthfirstLoginPasswordSetRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/(first-login)/invitation-expired': {
      id: '/_auth/(first-login)/invitation-expired'
      path: '/invitation-expired'
      fullPath: '/invitation-expired'
      preLoaderRoute: typeof AuthfirstLoginInvitationExpiredRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/(first-login)/first-time-login': {
      id: '/_auth/(first-login)/first-time-login'
      path: '/first-time-login'
      fullPath: '/first-time-login'
      preLoaderRoute: typeof AuthfirstLoginFirstTimeLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_app/consents/$templateId': {
      id: '/_app/consents/$templateId'
      path: '/consents/$templateId'
      fullPath: '/consents/$templateId'
      preLoaderRoute: typeof AppConsentsTemplateIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_plain/cockpit/$procedureId': {
      id: '/_plain/cockpit/$procedureId'
      path: '/cockpit/$procedureId'
      fullPath: '/cockpit/$procedureId'
      preLoaderRoute: typeof PlainCockpitProcedureIdRouteRouteImport
      parentRoute: typeof PlainRouteRoute
    }
    '/_app/subjects/$subjectId/': {
      id: '/_app/subjects/$subjectId/'
      path: '/subjects/$subjectId'
      fullPath: '/subjects/$subjectId'
      preLoaderRoute: typeof AppSubjectsSubjectIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/sites/$siteId/': {
      id: '/_app/sites/$siteId/'
      path: '/sites/$siteId'
      fullPath: '/sites/$siteId'
      preLoaderRoute: typeof AppSitesSiteIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/procedures/$procedureId/': {
      id: '/_app/procedures/$procedureId/'
      path: '/procedures/$procedureId'
      fullPath: '/procedures/$procedureId'
      preLoaderRoute: typeof AppProceduresProcedureIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/patients/$patientId/': {
      id: '/_app/patients/$patientId/'
      path: '/patients/$patientId'
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof AppPatientsPatientIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_plain/cockpit/$procedureId/treatment': {
      id: '/_plain/cockpit/$procedureId/treatment'
      path: '/treatment'
      fullPath: '/cockpit/$procedureId/treatment'
      preLoaderRoute: typeof PlainCockpitProcedureIdTreatmentRouteImport
      parentRoute: typeof PlainCockpitProcedureIdRouteRoute
    }
    '/_plain/cockpit/$procedureId/overview': {
      id: '/_plain/cockpit/$procedureId/overview'
      path: '/overview'
      fullPath: '/cockpit/$procedureId/overview'
      preLoaderRoute: typeof PlainCockpitProcedureIdOverviewRouteImport
      parentRoute: typeof PlainCockpitProcedureIdRouteRoute
    }
    '/_app/patients/$patientId/procedures/$procedureId/cueing/': {
      id: '/_app/patients/$patientId/procedures/$procedureId/cueing/'
      path: '/patients/$patientId/procedures/$procedureId/cueing'
      fullPath: '/patients/$patientId/procedures/$procedureId/cueing'
      preLoaderRoute: typeof AppPatientsPatientIdProceduresProcedureIdCueingIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/patients/$patientId/phases/$phaseId/assessments/$assessmentId/response': {
      id: '/_app/patients/$patientId/phases/$phaseId/assessments/$assessmentId/response'
      path: '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/response'
      fullPath: '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/response'
      preLoaderRoute: typeof AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdResponseRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/patients/$patientId/phases/$phaseId/assessments/$assessmentId/questionnaire': {
      id: '/_app/patients/$patientId/phases/$phaseId/assessments/$assessmentId/questionnaire'
      path: '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/questionnaire'
      fullPath: '/patients/$patientId/phases/$phaseId/assessments/$assessmentId/questionnaire'
      preLoaderRoute: typeof AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdQuestionnaireRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppAboutRoute: typeof AppAboutRoute
  AppIndexRoute: typeof AppIndexRoute
  AppConsentsTemplateIdRoute: typeof AppConsentsTemplateIdRoute
  AppConsentsIndexRoute: typeof AppConsentsIndexRoute
  AppPatientsIndexRoute: typeof AppPatientsIndexRoute
  AppProceduresIndexRoute: typeof AppProceduresIndexRoute
  AppSitesIndexRoute: typeof AppSitesIndexRoute
  AppPatientsPatientIdIndexRoute: typeof AppPatientsPatientIdIndexRoute
  AppProceduresProcedureIdIndexRoute: typeof AppProceduresProcedureIdIndexRoute
  AppSitesSiteIdIndexRoute: typeof AppSitesSiteIdIndexRoute
  AppSubjectsSubjectIdIndexRoute: typeof AppSubjectsSubjectIdIndexRoute
  AppPatientsPatientIdProceduresProcedureIdCueingIndexRoute: typeof AppPatientsPatientIdProceduresProcedureIdCueingIndexRoute
  AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdQuestionnaireRoute: typeof AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdQuestionnaireRoute
  AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdResponseRoute: typeof AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdResponseRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAboutRoute: AppAboutRoute,
  AppIndexRoute: AppIndexRoute,
  AppConsentsTemplateIdRoute: AppConsentsTemplateIdRoute,
  AppConsentsIndexRoute: AppConsentsIndexRoute,
  AppPatientsIndexRoute: AppPatientsIndexRoute,
  AppProceduresIndexRoute: AppProceduresIndexRoute,
  AppSitesIndexRoute: AppSitesIndexRoute,
  AppPatientsPatientIdIndexRoute: AppPatientsPatientIdIndexRoute,
  AppProceduresProcedureIdIndexRoute: AppProceduresProcedureIdIndexRoute,
  AppSitesSiteIdIndexRoute: AppSitesSiteIdIndexRoute,
  AppSubjectsSubjectIdIndexRoute: AppSubjectsSubjectIdIndexRoute,
  AppPatientsPatientIdProceduresProcedureIdCueingIndexRoute:
    AppPatientsPatientIdProceduresProcedureIdCueingIndexRoute,
  AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdQuestionnaireRoute:
    AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdQuestionnaireRoute,
  AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdResponseRoute:
    AppPatientsPatientIdPhasesPhaseIdAssessmentsAssessmentIdResponseRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthfirstLoginFirstTimeLoginRoute: typeof AuthfirstLoginFirstTimeLoginRoute
  AuthfirstLoginInvitationExpiredRoute: typeof AuthfirstLoginInvitationExpiredRoute
  AuthfirstLoginPasswordSetRoute: typeof AuthfirstLoginPasswordSetRoute
  AuthfirstLoginSetNewPasswordRoute: typeof AuthfirstLoginSetNewPasswordRoute
  AuthfirstLoginSetupMfaRoute: typeof AuthfirstLoginSetupMfaRoute
  AuthforgotPasswordCodeSentRoute: typeof AuthforgotPasswordCodeSentRoute
  AuthforgotPasswordForgotPasswordRoute: typeof AuthforgotPasswordForgotPasswordRoute
  AuthforgotPasswordPasswordUpdatedRoute: typeof AuthforgotPasswordPasswordUpdatedRoute
  AuthforgotPasswordResetPasswordRoute: typeof AuthforgotPasswordResetPasswordRoute
  AuthloginLoginRoute: typeof AuthloginLoginRoute
  AuthloginMfaRoute: typeof AuthloginMfaRoute
  AuthloginVerifyRoute: typeof AuthloginVerifyRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthfirstLoginFirstTimeLoginRoute: AuthfirstLoginFirstTimeLoginRoute,
  AuthfirstLoginInvitationExpiredRoute: AuthfirstLoginInvitationExpiredRoute,
  AuthfirstLoginPasswordSetRoute: AuthfirstLoginPasswordSetRoute,
  AuthfirstLoginSetNewPasswordRoute: AuthfirstLoginSetNewPasswordRoute,
  AuthfirstLoginSetupMfaRoute: AuthfirstLoginSetupMfaRoute,
  AuthforgotPasswordCodeSentRoute: AuthforgotPasswordCodeSentRoute,
  AuthforgotPasswordForgotPasswordRoute: AuthforgotPasswordForgotPasswordRoute,
  AuthforgotPasswordPasswordUpdatedRoute:
    AuthforgotPasswordPasswordUpdatedRoute,
  AuthforgotPasswordResetPasswordRoute: AuthforgotPasswordResetPasswordRoute,
  AuthloginLoginRoute: AuthloginLoginRoute,
  AuthloginMfaRoute: AuthloginMfaRoute,
  AuthloginVerifyRoute: AuthloginVerifyRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface PlainCockpitProcedureIdRouteRouteChildren {
  PlainCockpitProcedureIdOverviewRoute: typeof PlainCockpitProcedureIdOverviewRoute
  PlainCockpitProcedureIdTreatmentRoute: typeof PlainCockpitProcedureIdTreatmentRoute
}

const PlainCockpitProcedureIdRouteRouteChildren: PlainCockpitProcedureIdRouteRouteChildren =
  {
    PlainCockpitProcedureIdOverviewRoute: PlainCockpitProcedureIdOverviewRoute,
    PlainCockpitProcedureIdTreatmentRoute:
      PlainCockpitProcedureIdTreatmentRoute,
  }

const PlainCockpitProcedureIdRouteRouteWithChildren =
  PlainCockpitProcedureIdRouteRoute._addFileChildren(
    PlainCockpitProcedureIdRouteRouteChildren,
  )

interface PlainRouteRouteChildren {
  PlainCockpitProcedureIdRouteRoute: typeof PlainCockpitProcedureIdRouteRouteWithChildren
}

const PlainRouteRouteChildren: PlainRouteRouteChildren = {
  PlainCockpitProcedureIdRouteRoute:
    PlainCockpitProcedureIdRouteRouteWithChildren,
}

const PlainRouteRouteWithChildren = PlainRouteRoute._addFileChildren(
  PlainRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  PlainRouteRoute: PlainRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
